<template>
    <div>
        <commBanner :obj="obj"></commBanner>
        <titleHead :headTitle="headTitle"></titleHead>
        <div class="w80 mb-30">
            <el-container>
                <el-aside width="330px">
                    <sidebar></sidebar>
                </el-aside>
                <el-main>
                    <companySide v-if="type" :isButton="isButton" @release="gorelease()"></companySide>
                    <headSide v-else @release="gorelease()"></headSide>
                    <div style="margin-top:30px;">
                        <contTitle :obj="obj" :contTitle="contTitle"></contTitle>
                        <div class="download_content mt-20">
                          <div class="download_cont fdc" v-for="(item,index) in list" :key="index"  @click="onDetail(item)">
                            <div>
                                <img class="icon" src="../../assets/images/download_1.jpg" alt="">
                            </div>
                            <div class="download_cont_right">
                                <p class="download_title">{{item.goodsName}}</p>
                                 <div class="dowload_box">
                                    <p class=""><span>下载时间 :</span>
                                       <span v-if="item.transDate">{{item.transDate.substring(0,10)}}</span>
                                    </p>
                                    <p>
                                       <span class="ml-10">支付金额 :</span>
                                       <span class="attr">￥{{item.amount}}</span>
                                    </p>
                                 </div>
                            </div>
                          </div>
                        </div> 

                        <!--分页-->
                      <Pagination v-show="total>0"   :total="total"  :page.sync="listQuery.curPage" :limit.sync="listQuery.limit" @pageChange="pageChange" ></Pagination>

                      <div style="margin-top:20%">
                          <notList :notCode="notCode"></notList>
                      </div>
                    </div>
                </el-main>
            </el-container>
        </div>
    </div>
</template>
<script>
import {myDownloadFile} from "@/api/coment"
import sidebar from '../../common/sidebar'
import headSide from '../../common/headSide'
import companySide from "../../common/companySide";
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
import contTitle from '../../common/contTitle'
import Pagination from '../../components/Pagination'
import notList from '../../common/notList'
export default {
  components:{
      sidebar,headSide,companySide,commBanner,titleHead,contTitle,Pagination,notList
  },
  data(){
      return{
        contTitle:'我购买的资料',
        headTitle:'我的下载',
        obj:{
            title:'我的下载',      
            contCount:'',
            isShow:true,
            roleType:'',
            personalType:9
        },
        list:[],
        listQuery:{
          curPage:1,
          limit:6
        },
        total:0,//总条数
        notCode:false,
        type:false,
        isButton:false
      }
  },
  created(){
      this.getList();
      let type = this.$store.state.user.userInfo.type;
      this.obj.roleType = type;
      if(type == 3){
          this.type = true;
          this.headTitle = '企业下载';
          this.obj.title = '企业下载';
      }
  },
  methods:{
      //详情
      onDetail(item){
         switch(item.goodsType){
            case 1:
              this.$router.push({
                path:'/data_detail',
                query:{id:item.goodsId}
               });
             break;
             case 4:
              this.$router.push({
                path:'/environmental_college_detail',
                query:{id:item.goodsId}
               });
             break;  
         }
        
      },
      //列表
      getList(){
          myDownloadFile(this.listQuery).then((res)=>{
              if(res.code ==0){
                  this.list = res.page.list;
                  this.total = res.page.totalCount;
                  this.obj.contCount = res.page.totalCount;
                  this.list.length == 0 ? this.notCode = true : this.notCode = false;
              }
          }).catch((err)=>{})
      },
      //分页
      pageChange(item){
        this.listQuery['curPage'] = item.page;
        this.listQuery['limit'] = item.limit;
        this.getList();
      },
      //发布需求
      gorelease(){
        this.$router.push('/demand')
      },

  },  
}
</script>
<style scoped>
.ml-10{
    margin-left: 10px;
}
.mt-20{
    margin-top: 20px;
}
.needs_text{
  margin-left: 12px; 
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.download_content{
   display: flex;
   justify-content: space-between;
   align-items:center;
   flex-wrap: wrap;
}
.download_cont_right{
   width: 84%;
}
.download_cont{
    width: 49%;
    height: 110px; 
    border: 1px solid #DCDCDC;
    padding: 0px 20px;
    text-align: left;
    margin-bottom: 15px;
  	transition: all 0.5s;
}
.download_cont:hover{
    cursor: pointer;
    box-shadow: 0 0 20px #ddd;
}
.icon{
    width: 32px;
    height: 36px;
}
.dowload_box{
  display: flex;
  justify-content: space-between;
}
.dowload_box p{
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9A9A9A;
}
.download_title{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    display: inline-block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.download_text{
    margin-top: 8px;
    display: flex;
    justify-content: space-between;
}
.download_text span{   
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9A9A9A;
}
.attr{
   color: #FF7402;
}

.el-pagination{
   margin-top: 40px;
}
</style>


// WEBPACK FOOTER //
// src/view/coment/download.vue